export enum RuleEventTypesEnum {
  ASSIGN = 'assign',
  UNASSIGN = 'unassign',
  ARCHIVE = 'archive',
  SNOOZE = 'snooze',
  REOPEN = 'reopen',
  TOPIC_CLOSED = 'topic_closed',
  TOPIC_ADDED = 'topic_added',
  TOPIC_REMOVED = 'topic_removed',
  TRASH = 'trash',
  RESTORE = 'restore',
  REMINDER = 'reminder',
  COMMENT = 'comment',
  MENTION = 'mention',
  OUTBOUND = 'outbound',
  OUT_REPLY = 'out_reply',
  INBOUND = 'inbound',
  TAG = 'tag',
  UNTAG = 'untag',
  TAG_PRIVATE = 'tag_private',
  UNTAG_PRIVATE = 'untag_private',
  METADATA_EDITED = 'metadata_edited',
  MOVE = 'move',
  FORWARD = 'forward',
  SENDING_ERROR = 'sending_error',
  MESSAGE_BOUNCE_ERROR = 'message_bounce_error',
  CONVERSATION_JOINED = 'conv_join',
  CONVERSATION_ORIG_SPLIT = 'conv_orig_split',
  CONVERSATION_DEST_SPLIT = 'conv_dest_split',
  CONVERSATION_ORIG_AUTO_SPLIT = 'conv_orig_auto_split',
  CONVERSATION_DEST_AUTO_SPLIT = 'conv_dest_auto_split',
  MESSAGE_SEEN = 'message_seen',
  FOLLOW = 'follow',
  UNFOLLOW = 'unfollow',
  RULE_NOTIFY = 'rule_notify',
  TRACKER_ARCHIVE = 'tracker_archive',
  TRACKER_TRASH = 'tracker_trash',
  TRACKER_RESTORE = 'tracker_restore',
  TRACKER_UNARCHIVE = 'tracker_unarchive',
  TRACKER_REMINDER = 'tracker_reminder',
  TRACKER_SHARE = 'tracker_share',
  TRACKER_DRAFT_SHARE = 'tracker_draft_share',
}
